module.exports = __webpack_public_path__ + "static/media/emptymenu.05bda6b7.png";